<template>
    <div>
        <b-modal
            id="shipping_address_list_modal"
            modal-class=""
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">

                <div class="modal-base-head">
                    <div class="modal-base-close" @click="clickCloseAddressModal()"></div>
                    <div class="modal-headine-text">
                        {{lblShipping.headline}}
                    </div>
                </div>

                <div class="modal-base-body" v-if="arrAddressList">
                    <div class="address-item" v-if="arrAddressList.length > 0" >
                        <AddressListItem
                            v-for="(address, k) in arrAddressList"
                            :address="address"
                            :key="k"
                            :busEvent="busAddress"
                            @onDeleteAddress="onDeleteAddress($event)"
                            @onEditAddress="onEditAddress($event)"
                            @updateIsSelect="updateSelect($event)"
                        ></AddressListItem>
                    </div>
                    <div class="no-address" v-else>
                        <div class="no-address-img">
                            <img src="../../assets/icon/icon-no-address.svg"/> 
                        </div>
                        <div class="no-address-text">ไม่พบที่อยู่จัดส่ง</div>
                    </div>
                </div>

                <div class="modal-base-footer">
                    <div class="btn-add-address" @click="clickAddAddress()">เพิ่มที่อยู่จัดส่ง</div>
                    <button class="btn-select-address" :class="addessSelect != null ? 'allow' : ''" @click="clickConfirmAddress()">เลือกที่อยู่นี้</button>
                </div>
                
            </div>
        </b-modal>
    </div>
</template>
<script>
import Vue from "vue";
import AddressListItem from "@/components/address/AddressListItem.vue"
//helper
import Account from '@/helper/AccountHelper.js';
//service
import BzbsAddressList from "../../service/BzbsAddressList";
/**
 * Property
 * @property {lblShipping} (required) Text for component
 * @property {shippingAddress} (required) Shipping address model for redeem.
 * @property {errorInfo} (required) Validate status.
 * Event
 * @event clickConfirmAddress Validate and emit back to parent.
 * @event clickCloseShippingAddressModal Close modal.
 * Method
 * @method initialShippingAddressModal Setup shipping modal
 * @method closeShippingAddressModal Close modal.
 * @method validateForm Validate form.
 */
export default {
    name : 'ShippingAddressListModal',
    components: {
        AddressListItem,
    },
    props: {
        lblShipping: Object,

        busModal: Object,
        busShippingListModal: Object
    }, 
    data: function () {
        return {
            isSaveAddress: false,
            isShowErrorLbl: true,
            isFirstSave: true,
            arrErrorInfo: [],
            arrAddressList: [],
            addessSelect: null,

            busAddress: new Vue(),
        };
    },
    created: function () {
        for(var i = 0;i < 9; i++) {
            this.arrErrorInfo.push({
                isValid: true,
                msg: '',
            });
        }
    },
    mounted: function () {
        this.busShippingListModal.$on('showShippingAddressListModal', this.initialShippingAddressModal);
        this.busShippingListModal.$on('hideShippingAddressmodal', this.closeShippingAddressModal);
    },
    methods: {
        //Event
        clickConfirmAddress: function () {
            if (this.addessSelect == null) return; 
            this.$emit('onSelectAddress',this.addessSelect);
            this.closeAddressModal();
        },
        clickCloseAddressModal: function () {
            this.closeAddressModal();
        },
        clickAddAddress: function() {
            this.$emit('clickAddAddress', null);
            this.closeAddressModal();
        },
        //Function
        initialShippingAddressModal: function () {
            this.arrAddressList = []
            this.getAddressList()
            this.$bvModal.show('shipping_address_list_modal');
        },
        closeAddressModal: function () {
            this.$bvModal.hide('shipping_address_list_modal');
        },
        getAddressList: function() {
            var token = Account.getToken();
            BzbsAddressList.apiGetAddressList(token)
                .then(addressList => {
                    this.arrAddressList = addressList;
                    if (this.arrAddressList.length > 0) {
                        this.selectIsDefault()
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        validateForm: function () {
            //Set default.
            this.errorInfo.isValid = true;
            this.errorInfo.msg = '';
            //Check validate result and update.
            for(var error of this.arrErrorInfo) {
                if(!error.isValid) {
                    this.errorInfo.isValid = false;
                    this.errorInfo.msg = error.msg;
                    
                    return;
                }
            }
        },
        onEditAddress: function (address) {
            this.$emit('onEditAddress',address);
            this.closeAddressModal();
        },
        onDeleteAddress: function (address) {
            this.$emit('onDeleteAddress',address);
            this.closeAddressModal();
        },
        selectIsDefault: function () {
            for (let i in this.arrAddressList) {
                if (this.arrAddressList[i].isDefault) {
                    this.addessSelect = this.arrAddressList[i]
                }
            }
        },
        updateSelect: function (address) {
            for (let i in this.arrAddressList) {
                if (this.arrAddressList[i].rowKey == address.rowKey) {
                    this.arrAddressList[i].isSelect = true

                    this.addessSelect = this.arrAddressList[i]
                } else {
                    this.arrAddressList[i].isSelect = false
                }
            }
            this.busAddress.$emit('onUpdate', {});
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/component/modal/modal.scss";

#shipping_address_list_modal {
    @extend %modal-base;
    .modal-base {
        padding: 4px;
        .modal-headine-text{
            padding-top: 16px;
            text-align: center;
            font-size: 24px;
            font-weight: bold;
            color: #0e78c1;
        }
        .modal-base-body {
            height: 100%;
            max-height: calc(100vh - 300px);
            overflow-x: hidden;
            overflow-y: scroll;
            .address-item {
                display: flex;
                flex-flow: column;
                gap: 12px;
            }
            .no-address-img {
                img {
                    width: 60px;
                    height: 60px;
                }
            }
            .no-address {
                display: flex;
                flex-flow: column;
                align-items: center;
                gap: 12px;
                padding: 30px 0;
            }
        }
        .modal-base-footer {
            margin-top: 20px;
            .btn-add-address {
                text-align: center;
                font-size: 24px;
                font-weight: 500;
                text-decoration: underline;
                color: #0e78c1;
            }
            .btn-select-address {
                margin-top: 16px;
                width: 100%;
                border: #e9e9e9;
                border-radius: 5px;
                background-color: #e9e9e9;
                padding: 6px 0;
                font-size: 24px;
                font-weight: 500;
                color: #9f9f9f;
                &.allow {
                    color: white;
                    background-image: url('../../assets/campaign/button_redeem@2x.png');
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    background-position: center center;
                }
            }
        }
    }
}
</style>